import { Box, Text } from "@chakra-ui/react";

export function Tside({
  label,
  dashed = false,
  border = false,
  isDark = false,
}) {
  return (
    <>
      <Box
        textTransform={"uppercase"}
        bg={isDark ? "#3F5B66" : "#1A8AB6"}
        width="15rem"
        display="flex"
        alignItems="center"
        justifyContent="center"
        paddingBlock={1}
        position="relative"
        _after={
          border
            ? {
                content: "''",
                width: "100%",
                height: "1px",
                display: "block",
                backgroundColor: "#fff",
                position: "absolute",
                bottom: "0",
                left: "0",
                right: "0",
                margin: "auto",
              }
            : dashed
            ? {
                content: "''",
                width: "80%",
                height: "1px",
                display: "block",
                // backgroundColor: "#fff",
                //background image
                backgroundImage:
                  "radial-gradient(circle, white 1px, transparent 5px)",
                backgroundSize: "16px 4px",

                position: "absolute",
                bottom: "0",
                left: "0",
                right: "0",
                margin: "auto",
              }
            : {}
        }
      >
        <Text
          as="span"
          color="#fff"
          fontWeight={"normal"}
          textTransform={"uppercase"}
        >
          {label}
        </Text>
      </Box>
    </>
  );
}
